<div class="i-side-toc flex flex-col items-start h-full md:mt-4 text-xs">
	<div class="i-side-toc-title uppercase mb-2">On this page</div>
	<a *ngFor="let option of blogDetails.blogContentSectionList; let i = index"
	   [routerLink]="'/' +service+ '/'+ blogDetails.slug + '/'+ blogDetails.id" [fragment]="getURLId(option, i)"
	   [ngClass]="option.selected ? 'i-side-toc-anchor-selected': ''"
	   class="i-side-toc-anchor capitalize">{{getURLHeading(option, i)}}</a>
	<a *ngIf="blogDetails.faq"
	   [routerLink]="'/' +service+ '/'+ blogDetails.slug + '/'+ blogDetails.id" [fragment]="'faq-header'"
	   [ngClass]="blogDetails.faq.selected ? 'i-side-toc-anchor-selected': ''"
	   class="i-side-toc-anchor capitalize">{{blogDetails.faq.heading.toLowerCase()}}</a>
</div>
